(function () {
  'use strict';

  var CACHE_TTL_MS = 60 * 1000;

  function formatPrice(value, preformatted) {
    if (preformatted) return preformatted;
    if (value == null || value === '') return '';
    if (typeof value === 'number') return '₹' + Math.round(value);
    if (typeof value === 'string') {
      var stripped = value.replace(/,/g, '').trim();
      if (/^\d+(\.\d+)?$/.test(stripped)) return '₹' + Math.round(parseFloat(stripped));
    }
    return String(value);
  }

  function getPrice(product) {
    if (!product) return '';
    return formatPrice(product.price, product.priceFormatted);
  }

  function getComparePrice(product) {
    if (!product) return '';
    var raw = product.compareAtPrice != null ? product.compareAtPrice
            : product.compare_at_price != null ? product.compare_at_price
            : product.mrp != null ? product.mrp
            : product.originalPrice != null ? product.originalPrice
            : null;
    var formatted = product.compareAtPriceFormatted || product.compare_at_price_formatted || product.mrpFormatted;
    var out = formatPrice(raw, formatted);
    var cur = getPrice(product);
    if (!out || out === cur) return '';
    return out;
  }

  function productImage(product, fallback) {
    if (!product) return fallback || '';
    return product.imageSrc || product.image || product.imageUrl || product.featuredImage || product.featured_image || fallback || '';
  }

  function extractHandleFromPaths(paths) {
    if (!paths) return null;
    var list = Array.isArray(paths) ? paths : [paths];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (typeof p !== 'string') continue;
      var m = p.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  // Resolve a product-page URL from whatever the backend gave us. Tries, in
  // order: an explicit URL field on the product, a handle (locale-aware), then
  // any /products/ path recorded on the video.
  function getProductUrl(product, video) {
    if (!product) return null;

    var explicit = product.url || product.onlineStoreUrl || product.productUrl;
    if (typeof explicit === 'string' && explicit) return explicit;

    if (product.handle) {
      var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';
      return routeRoot + 'products/' + product.handle;
    }

    var paths = video && video.paths;
    var list = Array.isArray(paths) ? paths : (paths ? [paths] : []);
    for (var i = 0; i < list.length; i++) {
      if (typeof list[i] === 'string' && list[i].indexOf('/products/') !== -1) return list[i];
    }
    return null;
  }

  function getVariantId(product) {
    if (!product) return Promise.resolve(null);
    if (product.variantId) return Promise.resolve(product.variantId);
    return Promise.resolve(null);
  }

  function addToCart(variantId) {
    var body = {
      items: [{ id: variantId, quantity: 1 }],
      sections: 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble',
      sections_url: window.location.pathname
    };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add failed: ' + r.status);
      return r.json();
    });
  }

  // Best-effort cart drawer hookup. Themes wire carts differently, so this
  // tries a few common elements and silently no-ops if none match — the
  // dispatched `cart:refresh` event is the primary integration signal.
  function openCartDrawer(parsedState) {
    var miniCart = document.querySelector('mini-cart');
    if (miniCart && typeof miniCart.renderContents === 'function') {
      try { miniCart.renderContents(parsedState); return true; } catch (e) { log('mini-cart renderContents:', e); }
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.openMenuDrawer === 'function') {
      try { drawer.openMenuDrawer(); return true; } catch (e) {}
    }
    var trigger = document.querySelector('.cart-drawer-container');
    if (trigger && trigger.firstElementChild) {
      trigger.firstElementChild.click();
      return true;
    }
    return false;
  }

  function log() {
    if (window.console && console.error) console.error.apply(console, arguments);
  }

  function debug() {
    if (window.console && console.log) {
      var args = ['[shoppable-videos]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cacheKey(ctx, targetId) {
    return 'bv:shoppable-videos:' + ctx + ':' + (targetId || '');
  }

  function readCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || Date.now() - parsed.t > CACHE_TTL_MS) {
        sessionStorage.removeItem(key);
        return null;
      }
      return parsed.d;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data }));
    } catch (e) {
      /* quota exceeded — ignore */
    }
  }

  function fetchVideos(baseUrl, shopDomain, ctx, targetId) {
    var key = cacheKey(ctx, targetId);
    var cached = readCache(key);
    if (cached) return Promise.resolve(cached);

    var url = baseUrl.replace(/\/$/, '') + '/api/v1/shoppable-videos?context=' + encodeURIComponent(ctx);
    if (ctx !== 'homepage' && targetId) {
      url += '&targetId=' + encodeURIComponent(targetId);
    }

    return fetch(url, {
      method: 'GET',
      headers: { 'X-Shop-Domain': shopDomain, 'Accept': 'application/json' },
      credentials: 'omit'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Shoppable videos request failed: ' + res.status);
      }
      return res.json();
    }).then(function (json) {
      var list = (json && json.data) || [];
      writeCache(key, list);
      return list;
    });
  }

  function buildTile(video, idx) {
    var tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'shoppable-videos__tile';
    tile.setAttribute('role', 'listitem');
    tile.setAttribute('data-sv-tile', '');
    tile.setAttribute('data-sv-index', String(idx));

    var product = video.product;
    var title = product && product.title;
    tile.setAttribute('aria-label', title ? 'Play video for ' + title : 'Play shoppable video');

    // ---- Media (video + optional thumbnail) ----
    var media = document.createElement('span');
    media.className = 'shoppable-videos__tile-media';

    var v = document.createElement('video');
    v.className = 'shoppable-videos__tile-video';
    v.src = video.videoUrl;
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.preload = 'metadata';
    if (video.thumbnailUrl) v.poster = video.thumbnailUrl;
    if (title) v.setAttribute('aria-label', title);
    media.appendChild(v);

    // Product-image badge overlapping the bottom of the video
    var thumbSrc = productImage(product);
    if (thumbSrc) {
      var thumb = document.createElement('img');
      thumb.className = 'shoppable-videos__tile-thumb';
      thumb.src = thumbSrc;
      thumb.alt = title || '';
      thumb.loading = 'lazy';
      media.appendChild(thumb);
    }

    tile.appendChild(media);

    // ---- Footer (title + price) — only when the video has a linked product ----
    var priceText = getPrice(product);
    if (title || priceText) {
      var footer = document.createElement('span');
      footer.className = 'shoppable-videos__tile-footer';

      if (title) {
        var titleEl = document.createElement('span');
        titleEl.className = 'shoppable-videos__tile-title';
        titleEl.textContent = title;
        footer.appendChild(titleEl);
      }

      if (priceText) {
        var priceWrap = document.createElement('span');
        priceWrap.className = 'shoppable-videos__tile-price';

        var priceCurrent = document.createElement('span');
        priceCurrent.className = 'shoppable-videos__tile-price-current';
        priceCurrent.textContent = priceText;
        priceWrap.appendChild(priceCurrent);

        // Struck-through compare-at price, when the product data carries one
        var compareText = getComparePrice(product);
        if (compareText) {
          var priceCompare = document.createElement('span');
          priceCompare.className = 'shoppable-videos__tile-price-compare';
          priceCompare.textContent = compareText;
          priceWrap.appendChild(priceCompare);
        }

        footer.appendChild(priceWrap);
      }

      tile.appendChild(footer);
    }

    return tile;
  }

  function setupTileAutoplayObserver(carousel) {
    if (prefersReducedMotion()) return null;
    if (!('IntersectionObserver' in window)) return null;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var vid = entry.target.querySelector('video');
        if (!vid) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          // Loop only the first 3 seconds on the rail: play 0→3s, restart.
          try { vid.currentTime = 0; } catch (e) {}
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
          if (vid._svPreviewTimer) clearInterval(vid._svPreviewTimer);
          vid._svPreviewTimer = setInterval(function () {
            try { vid.currentTime = 0; } catch (e) {}
            var rp = vid.play();
            if (rp && rp.catch) rp.catch(function () {});
          }, 3000);
        } else {
          if (vid._svPreviewTimer) {
            clearInterval(vid._svPreviewTimer);
            vid._svPreviewTimer = 0;
          }
          vid.pause();
        }
      });
    }, { root: carousel, threshold: [0, 0.6, 1] });

    return io;
  }

  /* ===== Reels-style modal ===== */

  function ReelsModal(root) {
    this.root = root;
    this.modal = root.querySelector('[data-sv-modal]');
    this.track = root.querySelector('[data-sv-reels-track]');
    this.soundBtn = root.querySelector('[data-sv-sound-toggle]');
    this.soundOnIcon = root.querySelector('[data-sv-sound-on]');
    this.soundOffIcon = root.querySelector('[data-sv-sound-off]');
    this.prevBtn = root.querySelector('[data-sv-prev]');
    this.nextBtn = root.querySelector('[data-sv-next]');
    this.layout = root.dataset.layout === 'horizontal' ? 'horizontal' : 'vertical';
    this.modal.setAttribute('data-sv-layout', this.layout);
    // The horizontal carousel is desktop-only; on mobile the player behaves
    // like the vertical reels (matches the CSS @media min-width: 750px gate).
    this.desktopMql = window.matchMedia('(min-width: 750px)');
    this._scrollRaf = 0;
    this.pdpProduct = {
      handle: root.dataset.productHandle || '',
      variantId: root.dataset.productVariantId ? parseInt(root.dataset.productVariantId, 10) : null,
      price: root.dataset.productPrice || '',
      compareAtPrice: root.dataset.productCompareAtPrice || '',
      image: root.dataset.productImage || ''
    };
    this.shopDomain = root.dataset.shopDomain || '';
    this.storefrontToken = root.dataset.storefrontToken || '';
    this.storefrontApiVersion = root.dataset.storefrontApiVersion || '2024-10';
    this.productUrlsPromise = null;
    this.videos = [];
    this.reels = [];
    this.observer = null;
    this.currentIndex = -1;
    this.muted = false;
    this.savedTimes = {};
    this.lastFocus = null;

    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sv-modal-close]'), function (el) {
      el.addEventListener('click', function () { self.close(); });
    });
    document.addEventListener('keydown', function (e) {
      if (self.modal.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        self.close();
      } else if (self.effectiveLayout() === 'horizontal' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault();
        self.step(e.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    this.soundBtn.addEventListener('click', function () {
      self.setMuted(!self.muted);
    });
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () { self.step(-1); });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () { self.step(1); });
    }
    this.updateSoundIcon();
  }

  ReelsModal.prototype.setVideos = function (videos) {
    this.videos = videos || [];
  };

  // Resolve product-page URLs for reels that arrive without a handle (e.g. the
  // homepage feed, which only carries a Shopify product GID). One batched
  // Storefront API call maps every GID -> handle/onlineStoreUrl and writes the
  // result back onto each video's product so getProductUrl() can read it.
  // Idempotent: the fetch fires at most once and its promise is reused.
  ReelsModal.prototype.ensureProductUrls = function () {
    if (this.productUrlsPromise) return this.productUrlsPromise;

    var self = this;
    var gids = [];
    var seen = {};
    (this.videos || []).forEach(function (video) {
      var p = video.product || video.productInfo || video.productData;
      if (p && p.handle) return; // already linkable, no lookup needed
      var gid = (p && p.shopifyId) || video.shopifyProductId;
      if (typeof gid === 'string' && gid.indexOf('gid://shopify/Product/') === 0 && !seen[gid]) {
        seen[gid] = true;
        gids.push(gid);
      }
    });

    if (!this.storefrontToken || !this.shopDomain || !gids.length) {
      this.productUrlsPromise = Promise.resolve();
      return this.productUrlsPromise;
    }

    var endpoint = 'https://' + this.shopDomain + '/api/' + this.storefrontApiVersion + '/graphql.json';
    var query = '{ nodes(ids: ' + JSON.stringify(gids) + ') { ... on Product { id handle onlineStoreUrl } } }';

    this.productUrlsPromise = fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.storefrontToken
      },
      body: JSON.stringify({ query: query })
    }).then(function (res) {
      if (!res.ok) throw new Error('Storefront API ' + res.status);
      return res.json();
    }).then(function (json) {
      var nodes = (json && json.data && json.data.nodes) || [];
      var map = {};
      nodes.forEach(function (node) {
        if (node && node.id) map[node.id] = node;
      });
      (self.videos || []).forEach(function (video) {
        // Mutate the same product object buildReels() reads (same precedence).
        var p = video.product || video.productInfo || video.productData;
        var gid = (p && p.shopifyId) || video.shopifyProductId;
        var node = gid && map[gid];
        if (!node) return;
        if (!p) { p = {}; video.product = p; }
        if (!p.handle && node.handle) p.handle = node.handle;
        if (!p.onlineStoreUrl && node.onlineStoreUrl) p.onlineStoreUrl = node.onlineStoreUrl;
      });
    }).catch(function (err) {
      log('shoppable-videos storefront resolve:', err);
    });

    return this.productUrlsPromise;
  };

  // 'horizontal' only when the section is set to horizontal AND we're at a
  // desktop width; otherwise 'vertical' (mobile reels).
  ReelsModal.prototype.effectiveLayout = function () {
    return this.layout === 'horizontal' && this.desktopMql.matches ? 'horizontal' : 'vertical';
  };

  ReelsModal.prototype.buildReels = function () {
    this.track.innerHTML = '';
    this.reels = [];
    var self = this;

    this.videos.forEach(function (video, idx) {
      var reel = document.createElement('div');
      reel.className = 'shoppable-videos__reel';
      reel.setAttribute('data-sv-reel-index', String(idx));

      var v = document.createElement('video');
      v.className = 'shoppable-videos__reel-video';
      v.src = video.videoUrl;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.muted = self.muted;
      if (self.muted) v.setAttribute('muted', '');
      v.preload = 'metadata';
      if (video.thumbnailUrl) v.poster = video.thumbnailUrl;
      reel.appendChild(v);

      // Tap on video toggles play/pause
      v.addEventListener('click', function () {
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });

      // Product card overlay — accept either video.product or flat fields on the video itself
      var product = video.product || video.productInfo || video.productData || null;
      if (!product) {
        if (video.productTitle || video.title || video.productHandle || video.handle || video.price != null) {
          product = {
            title: video.productTitle || video.title,
            handle: video.productHandle || video.handle,
            price: video.price,
            priceFormatted: video.priceFormatted,
            compareAtPrice: video.compareAtPrice || video.compare_at_price || video.mrp || video.originalPrice,
            compareAtPriceFormatted: video.compareAtPriceFormatted || video.mrpFormatted,
            image: video.productImage || video.image || video.imageUrl,
            variantId: video.variantId || video.variant_id
          };
        }
      }
      // Merge in PDP-injected values (variantId, compareAtPrice) since all reels are for the current product
      if (product && self.pdpProduct) {
        if (!product.variantId && self.pdpProduct.variantId) product.variantId = self.pdpProduct.variantId;
        if (!product.compareAtPrice && self.pdpProduct.compareAtPrice) product.compareAtPrice = self.pdpProduct.compareAtPrice;
        if (!product.handle && self.pdpProduct.handle) product.handle = self.pdpProduct.handle;
      }
      if (product && !product.handle) {
        var derivedHandle = extractHandleFromPaths(video.paths);
        if (derivedHandle) product.handle = derivedHandle;
      }

      if (product) {
        var card = document.createElement('div');
        card.className = 'shoppable-videos__reel-card';

        var imgSrc = productImage(product, video.thumbnailUrl);
        if (imgSrc) {
          var img = document.createElement('img');
          img.className = 'shoppable-videos__reel-card-img';
          img.src = imgSrc;
          img.alt = product.title || '';
          img.loading = 'lazy';
          card.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'shoppable-videos__reel-card-info';

        var titleEl = document.createElement('p');
        titleEl.className = 'shoppable-videos__reel-card-title';
        titleEl.textContent = product.title || '';
        info.appendChild(titleEl);

        var priceText = getPrice(product);
        var compareText = getComparePrice(product);
        var priceEl = document.createElement('p');
        priceEl.className = 'shoppable-videos__reel-card-price';
        if (priceText) {
          var priceCurrent = document.createElement('span');
          priceCurrent.className = 'shoppable-videos__reel-card-price-current';
          priceCurrent.textContent = priceText;
          priceEl.appendChild(priceCurrent);
        }
        if (compareText) {
          var priceCompare = document.createElement('span');
          priceCompare.className = 'shoppable-videos__reel-card-price-compare';
          priceCompare.textContent = compareText;
          priceEl.appendChild(priceCompare);
        }
        info.appendChild(priceEl);
        card.appendChild(info);

        var productUrl = getProductUrl(product, video);
        if (productUrl) {
          var btn = document.createElement('a');
          btn.className = 'shoppable-videos__reel-card-btn';
          btn.href = productUrl;
          btn.textContent = 'View';
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
          });
          card.appendChild(btn);
        }

        reel.appendChild(card);
      }

      self.track.appendChild(reel);

      self.reels.push({
        video: video,
        videoEl: v,
        reelEl: reel
      });
    });
  };

  ReelsModal.prototype.setupActivation = function () {
    if (this.effectiveLayout() === 'horizontal') {
      this.setupScrollActivation();
    } else {
      this.setupObserver();
    }
  };

  // Horizontal layout: reels peek on both sides, so several intersect the
  // viewport at once. Pick the one whose centre is nearest the track centre.
  ReelsModal.prototype.setupScrollActivation = function () {
    var self = this;
    this.teardownScrollActivation();

    function pickNearest() {
      self._scrollRaf = 0;
      var center = self.track.scrollLeft + self.track.clientWidth / 2;
      var best = -1;
      var bestDist = Infinity;
      for (var i = 0; i < self.reels.length; i++) {
        var el = self.reels[i].reelEl;
        var elCenter = el.offsetLeft + el.clientWidth / 2;
        var dist = Math.abs(elCenter - center);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      if (best !== -1 && best !== self.currentIndex) self.activate(best);
    }

    this._onScroll = function () {
      if (self._scrollRaf) return;
      self._scrollRaf = window.requestAnimationFrame(pickNearest);
    };
    this.track.addEventListener('scroll', this._onScroll, { passive: true });
    pickNearest();
  };

  ReelsModal.prototype.teardownScrollActivation = function () {
    if (this._onScroll) {
      this.track.removeEventListener('scroll', this._onScroll);
      this._onScroll = null;
    }
    if (this._scrollRaf) {
      window.cancelAnimationFrame(this._scrollRaf);
      this._scrollRaf = 0;
    }
  };

  ReelsModal.prototype.setupObserver = function () {
    if (this.observer) this.observer.disconnect();
    var self = this;
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = parseInt(entry.target.getAttribute('data-sv-reel-index'), 10);
        if (isNaN(idx)) return;
        var item = self.reels[idx];
        if (!item) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
          self.activate(idx);
        } else {
          self.deactivate(idx);
        }
      });
    }, { root: this.track, threshold: [0, 0.5, 0.7, 1] });

    this.reels.forEach(function (entry) {
      self.observer.observe(entry.reelEl);
    });
  };

  ReelsModal.prototype.activate = function (idx) {
    if (this.currentIndex === idx) return;
    if (this.currentIndex !== -1) this.deactivate(this.currentIndex);

    this.currentIndex = idx;
    var entry = this.reels[idx];
    if (!entry) return;

    entry.reelEl.setAttribute('data-sv-active', '');
    // Horizontal layout: dock the sound toggle into the active tile's corner.
    if (this.effectiveLayout() === 'horizontal' && this.soundBtn) {
      entry.reelEl.appendChild(this.soundBtn);
    }
    this.updateNav();

    var v = entry.videoEl;
    var saved = this.savedTimes[idx];
    if (typeof saved === 'number' && !isNaN(saved)) {
      try { v.currentTime = saved; } catch (e) {}
    }
    v.muted = this.muted;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };

  ReelsModal.prototype.deactivate = function (idx) {
    var entry = this.reels[idx];
    if (!entry) return;
    entry.reelEl.removeAttribute('data-sv-active');
    var v = entry.videoEl;
    if (!isNaN(v.currentTime)) this.savedTimes[idx] = v.currentTime;
    v.pause();
    if (this.currentIndex === idx) this.currentIndex = -1;
  };

  // Disable the prev/next arrows at the ends of the list (horizontal layout).
  ReelsModal.prototype.updateNav = function () {
    if (this.effectiveLayout() !== 'horizontal') return;
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.reels.length - 1;
  };

  // Scroll the requested reel into view; activation follows from the scroll
  // observer (horizontal) or the IntersectionObserver (vertical).
  ReelsModal.prototype.goTo = function (idx) {
    var entry = this.reels[idx];
    if (!entry) return;
    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    if (this.effectiveLayout() === 'horizontal') {
      var left = entry.reelEl.offsetLeft - (this.track.clientWidth - entry.reelEl.clientWidth) / 2;
      this.track.scrollTo({ left: left, top: 0, behavior: behavior });
    } else {
      this.track.scrollTo({ top: entry.reelEl.offsetTop, left: 0, behavior: behavior });
    }
  };

  ReelsModal.prototype.step = function (dir) {
    var base = this.currentIndex === -1 ? 0 : this.currentIndex;
    var next = base + dir;
    if (next < 0 || next >= this.reels.length) return;
    this.goTo(next);
  };

  ReelsModal.prototype.setMuted = function (muted) {
    this.muted = !!muted;
    this.reels.forEach(function (entry) {
      entry.videoEl.muted = muted;
    });
    this.soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    this.updateSoundIcon();
  };

  ReelsModal.prototype.updateSoundIcon = function () {
    if (this.muted) {
      this.soundOnIcon.hidden = true;
      this.soundOffIcon.hidden = false;
    } else {
      this.soundOnIcon.hidden = false;
      this.soundOffIcon.hidden = true;
    }
  };

  ReelsModal.prototype.open = function (startIdx) {
    var self = this;
    this.lastFocus = document.activeElement;
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';

    // Resolve product URLs first so the reel cards render with a "View" link.
    // The promise is usually already settled (prefetched at init), so this is
    // instant in practice; it resolves immediately when there's nothing to look up.
    this.ensureProductUrls().then(function () {
      if (!self.reels.length) self.buildReels();

      var target = self.reels[startIdx];
      if (target) {
        // Jump to selected reel without smooth scroll first
        if (self.effectiveLayout() === 'horizontal') {
          var left = target.reelEl.offsetLeft - (self.track.clientWidth - target.reelEl.clientWidth) / 2;
          self.track.scrollTo({ left: left, top: 0, behavior: 'auto' });
        } else {
          self.track.scrollTo({ top: target.reelEl.offsetTop, left: 0, behavior: 'auto' });
        }
      }

      // Set up activation after positioning so the first pick lands on the target.
      self.setupActivation();
    });
  };

  ReelsModal.prototype.close = function () {
    var self = this;
    this.reels.forEach(function (_, idx) {
      self.deactivate(idx);
    });
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.teardownScrollActivation();
    this.modal.hidden = true;
    document.body.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ===== Section init ===== */

  function init(root) {
    var baseUrl = root.dataset.backendBaseUrl;
    var shopDomain = root.dataset.shopDomain;
    var ctx = root.dataset.context;
    var targetId = root.dataset.targetId;
    var maxVideos = parseInt(root.dataset.maxVideos, 10) || 8;

    debug('init', { baseUrl: baseUrl, shopDomain: shopDomain, ctx: ctx, targetId: targetId, maxVideos: maxVideos });

    if (!baseUrl || !shopDomain) {
      log('shoppable-videos: missing backend base URL or shop domain');
      return;
    }

    if (ctx === 'product' && !targetId) {
      debug('aborting: product context but no targetId resolved');
      return;
    }
    if (ctx === 'collection' && !targetId) {
      debug('aborting: collection context but no targetId resolved');
      return;
    }

    fetchVideos(baseUrl, shopDomain, ctx, targetId).then(function (videos) {
      debug('fetched videos', { count: videos ? videos.length : 0 });
      if (!videos || !videos.length) {
        debug('no videos returned, section stays hidden');
        return;
      }

      var limited = videos.slice(0, maxVideos);
      var carousel = root.querySelector('[data-sv-carousel]');
      var modal = new ReelsModal(root);
      modal.setVideos(limited);
      // Kick off product-URL resolution in the background so it's ready by the
      // time a tile is tapped (non-blocking; open() awaits the same promise).
      modal.ensureProductUrls();
      var io = setupTileAutoplayObserver(carousel);

      limited.forEach(function (video, idx) {
        var tile = buildTile(video, idx);
        tile.addEventListener('click', function () { modal.open(idx); });
        carousel.appendChild(tile);
        if (io) io.observe(tile);
      });

      root.hidden = false;
      root.setAttribute('data-sv-visible', '');
      debug('rendered', limited.length, 'tile(s)');
    }).catch(function (err) {
      log('shoppable-videos:', err);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-shoppable-videos]');
    debug('boot — section roots found:', roots.length);
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
